module.exports = __webpack_public_path__ + "media/images/covers/foundation/Manchester-Metropolitan-University-logo-d359151cffa009bcd172847a708dbf99.svg";